import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useDeviceTypesOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isDesktopDevicesLoading,
    data: desktopDevices,
    refetch: desktopDevicesRefetch,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Desktop Devices types'),
    optionType: OptionsType.DESKTOP_DEVICES,
    queryOptions,
  });

  const {
    isLoading: isMobileDevicesLoading,
    data: mobileDevices,
    refetch: mobileDevicesRefetch,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Mobile Devices types'),
    optionType: OptionsType.MOBILE_DEVICES,
    queryOptions,
  });

  const {
    isLoading: isTVDevicesLoading,
    data: tvDevices,
    refetch: tvDevicesRefetch,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch TV Devices types'),
    optionType: OptionsType.TV_DEVICES,
    queryOptions,
  });

  return useMemo(
    () => ({
      [OptionsType.DESKTOP_DEVICES]: {
        isLoading: isDesktopDevicesLoading,
        data: desktopDevices,
        refetch: desktopDevicesRefetch,
      },
      [OptionsType.MOBILE_DEVICES]: {
        isLoading: isMobileDevicesLoading,
        data: mobileDevices,
        refetch: mobileDevicesRefetch,
      },
      [OptionsType.TV_DEVICES]: {
        isLoading: isTVDevicesLoading,
        data: tvDevices,
        refetch: tvDevicesRefetch,
      },
    }),
    [
      desktopDevices,
      desktopDevicesRefetch,
      isDesktopDevicesLoading,
      isMobileDevicesLoading,
      isTVDevicesLoading,
      mobileDevices,
      mobileDevicesRefetch,
      tvDevices,
      tvDevicesRefetch,
    ]
  );
}
